import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  computed,
  effect,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsComponent } from '@enginuity/core/molecules/inputs/inputs.component';
import { ButtonsComponent } from '@enginuity/core/molecules/buttons/buttons.component';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';
import { DatatypesComponent } from '@enginuity/core/atoms/datatypes/datatypes.component';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import {
  STRING_COMPARISON_FILTERS,
  EVENTS_COMPARISON_FILTERS,
  NUMBER_COMPARISON_FILTERS,
  BOOLEAN_COMPARISON_FILTERS,
  dateOperators,
  statusOperators,
} from '@services/ui-services/constants/table-filter.constant';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormErrorsService } from '@services/form-services/form-errors.service';

@Component({
  selector: 'app-filter-condition',
  imports: [
    CommonModule,
    InputsComponent,
    ButtonsComponent,
    DatatypesComponent,
    BadgesComponent,
    DropdownComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './filter-condition.component.html',
  styleUrls: ['./filter-condition.component.scss'],
})
export class FilterConditionComponent implements OnInit {
  @Output() customClick = new EventEmitter<object>();
  btnType = 'withoutIcon';

  @Input() set filter(value: any) {
    if (value) {
      console.log('values', value);
      this._filter = value;
      this.filterSignal.set(value);
    }
  }
  _filter: any = {
    join_condition_by: 'string',
    name: 'Business Name',
    fieldName: 'first_name',
    icon: 'balance',
    radio: true,
    toggle: true,

    isShow: true,
    details: {
      label: 'Business Name',
      content: 'Triggered when a user completes their pruchase in the checkout flow.',
    },
    filter_in: 'data',
  };

  filterSignal = signal({
    join_condition_by: 'string',
    name: 'Business Name',
    fieldName: 'first_name',
    icon: 'balance',
    radio: true,
    toggle: true,

    isShow: true,
    details: {
      label: 'Business Name',
      content: 'Triggered when a user completes their pruchase in the checkout flow.',
    },
    filter_in: 'data',
  });

  // comparisonFiltersArraySignal = computed(() => {
  //   if (
  //     this.filterSignal().join_condition_by == 'number' ||
  //     this.filterSignal().join_condition_by == 'date'
  //   ) {
  //     return dateOperators;
  //   } else if (this.filterSignal().join_condition_by == 'boolean') {
  //     return BOOLEAN_COMPARISON_FILTERS;
  //   } else if (this.filterSignal().join_condition_by == 'date') {
  //     return EVENTS_COMPARISON_FILTERS;
  //   }
  //   return STRING_COMPARISON_FILTERS;
  // });

  comparisonFiltersArraySignal = computed(() => {
    const joinConditionBy = this.filterSignal().join_condition_by;
    switch (joinConditionBy) {
      case 'number':
        return NUMBER_COMPARISON_FILTERS;
      case 'date':
        return dateOperators;
      case 'status':
        return statusOperators;
      case 'payment_status':
        return statusOperators;
      case 'boolean':
        return BOOLEAN_COMPARISON_FILTERS;
      default:
        return STRING_COMPARISON_FILTERS;
    }
  });

  selectedCondition = this.comparisonFiltersArraySignal()[0];
  arrayUpdateEffect = effect(() => {
    this.selectedCondition = this.comparisonFiltersArraySignal()[0];
  });

  form!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private formError: FormErrorsService
  ) {}

  ngOnInit(): void {
    this.selectedCondition = this.comparisonFiltersArraySignal()[0];

    console.log('Comprastion', this.selectedCondition);
    this.form = this.fb.group({
      input1: ['', Validators.required],
    });
  }
  options: any[] = [];
  // options: any = [
  //   { value: 'option1', label: 'Option 1' },
  //   { value: 'option2', label: 'Option 2' },
  //   { value: 'option3', label: 'Option 3' },
  // ]

  onDropdownChange(event: any) {
    this.selectedCondition = event;
    if (event.multipleInputs) {
      this.form = this.fb.group({
        input1: ['', Validators.required],
        input2: ['', Validators.required],
      });
    } else {
      this.form = this.fb.group({
        input1: ['', Validators.required],
      });
    }
  }

  onChange(event: any) {
    // if (this.filterSignal().join_condition_by === 'status') {
    //   const selectedOption = event.value;
    //   if (selectedOption) {
    //     this._filter.filter_value = selectedOption.value;
    //   }
    // }
  }

  getErrorMsg(control: AbstractControl | null, field: string) {
    const error = this.formError.getErrorMsg(control, field);
    if (error) {
      this.filter.alert = true;
      return error;
    } else {
      return '';
    }
  }

  onSave() {
    this._filter.value = '';
    this._filter.filterValue = this.selectedCondition.name;
    this._filter.alert = false;
    const filters: any = [];

    Object.keys(this.form.controls).forEach(key => {
      filters.push(this.getFilterObject(key));
    });

    if (this.selectedCondition.multipleInputs) {
      this._filter.value = `
      ${this.form.controls['input1'].value} -
        ${this.form.controls['input2'].value}`;
    }
    const dateFilterIndex = filters.findIndex((filter: any) => filter.data_type === 'date');
    if (dateFilterIndex !== -1) {
      const dateValue = filters[dateFilterIndex].filter_value;
      const formattedDate = this.formatDateForAPI(dateValue);
      filters[dateFilterIndex].filter_value = formattedDate;
      this._filter.filter_value = formattedDate;
    } else if (
      this._filter.join_condition_by === 'status' ||
      this._filter.join_condition_by === 'payment_status'
    ) {
      // If join_condition_by is 'status', set filter_value to the value property of input1
      const input1Value = this.form.controls['input1'].value;
      if (input1Value && input1Value.value) {
        this._filter.filter_value = input1Value.value;
      } else {
        this._filter.filter_value = null; // or any default value you want to assign
      }
    }

    this.customClick.emit({
      action: 'filter_tag_search',
      value: filters,
    });
  }

  formatDateForAPI(dateString: string): string {
    const dateParts = dateString.split(' ');
    const day = dateParts[0];
    const month = this.getMonthNumber(dateParts[1]);
    const year = dateParts[2];
    return `${year}-${month}-${day}`;
  }

  getMonthNumber(monthName: string): string {
    const months: { [key: string]: string } = {
      Jan: '01',
      Feb: '02',
      Mar: '03',
      Apr: '04',
      May: '05',
      Jun: '06',
      Jul: '07',
      Aug: '08',
      Sep: '09',
      Oct: '10',
      Nov: '11',
      Dec: '12',
    };
    return months[monthName];
  }

  getFilterObject(control: any) {
    const filterValue: any = {
      join_condition_by: this._filter.join_condition_by,
      filter_in: this._filter.filter_in,
      filter_by: this._filter.fieldName,
      label: this._filter.name,
    };

    const value = this.form.controls[control].value;

    if (value != '' && value != null) {
      if (this._filter.join_condition_by === 'date') {
        // Format date value before setting it
        const formattedDate = this.formatDateForAPI(value);
        filterValue.filter_value = formattedDate;
        this._filter.filter_value = formattedDate;
      } else if (
        this._filter.join_condition_by === 'status' ||
        this._filter.join_condition_by === 'payment_status'
      ) {
        // Format date value before setting it
        filterValue.filter_value = value.value;
        this._filter.filter_value = value.value;
      } else {
        filterValue.filter_value = value;
        this._filter.filter_value = value;
      }
    }

    // For multiple date inputs, set the appropriate filter operator
    if (this.selectedCondition.multipleInputs && control === 'input2') {
      // For the second input of "Between" operator
      filterValue.filter_operator = 'less-or-equal';
      filterValue.second_comparison_key = 'less-or-equal';
    } else {
      if (this.selectedCondition.comparison_key === 'between') {
        // For the first input of "Between" operator
        filterValue.filter_operator = 'greater-or-equal';
      } else {
        filterValue.filter_operator = this.selectedCondition.comparison_key;
      }
    }

    return filterValue;
  }
  onEnterKeyPress() {
    this.onSave();
    this.btnType = 'onlyIcon';
    setTimeout(() => {
      this.btnType = 'withoutIcon';
    }, 600); // Hide the message after 2 seconds (adjust as needed)
  }

  getValue(event: any, filter: any) {
    console.log('date:', event);
  }
}
